(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jpi-search-reading"] && !Shopify.designMode) return;
  try {
    /* TIMESTAMP START 2026-10-25T10:26:43-04:00 | REVISION R000037 */
  if (!customElements.get('jpi-search-reading')) {
    customElements.define('jpi-search-reading', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        // The URL is the canonical query; never search an HTML-encoded label.
        this.query = new URL(location.href).searchParams.get('q') ?? this.dataset.query;
        this.addEventListener('click', event => {
          const link = event.target.closest('a[data-reading-page]');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.load(Number(link.dataset.readingPage), true);
        });
        const intro = this.querySelector('[data-reading-intro]');
        if (intro) intro.textContent = intro.dataset.introTemplate.replace('__JPI_QUERY__', this.query);
        this.repairReadingLinks();
        this.selectEvent();
        this.normalizeProducts();
        if (this.dataset.ready !== 'true') this.load(1, false);
      }
      disconnectedCallback() {
        this.readingController?.abort();
        this.productController?.abort();
      }
      searchURL(types, page) {
        const url = new URL(this.dataset.searchUrl, location.origin);
        url.searchParams.set('q', this.query);
        url.searchParams.set('type', types);
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', this.dataset.section);
        return url;
      }
      repairReadingLinks() {
        const pagination = this.querySelector('[data-reading-pagination]');
        if (pagination) {
          pagination.querySelector('nav')?.setAttribute('aria-label', this.dataset.paginationLabel);
          pagination.querySelectorAll('a[href]').forEach(link => { link.dataset.readingPage = new URL(link.href, location.origin).searchParams.get('page') || '1'; });
        }
        this.querySelectorAll('.jpi-reading__all, a[data-reading-page]').forEach(link => {
          const url = this.searchURL('article,page', Number(link.dataset.readingPage || 1));
          url.searchParams.delete('section_id');
          if (!link.dataset.readingPage) url.searchParams.delete('page');
          url.hash = 'jpi-search-reading';
          link.href = url;
        });
      }
      selectEvent() {
        const normalize = value => value.toLocaleLowerCase().normalize('NFKC').match(/[\p{L}\p{N}]+/gu) || [];
        const stop = new Set(['and','the','for','with','from','about','into','this','that','are','was','not','but','you','your','our','event','events']);
        const terms = [...new Set(normalize(this.query))].filter(term => term.length >= 3 && !stop.has(term));
        if (!terms.length) return;
        const candidates = [...this.querySelectorAll('template[data-event-candidate]')].map(template => {
          const title = normalize(template.dataset.eventTitle);
          const body = normalize(template.dataset.eventText);
          const score = terms.reduce((sum,term) => sum + (title.some(word => word.startsWith(term)) ? 4 : body.some(word => word.startsWith(term)) ? 1 : 0), 0);
          return {template,score};
        }).filter(item => item.score > 0).sort((a,b) => b.score-a.score || a.template.dataset.start.localeCompare(b.template.dataset.start) || a.template.dataset.eventId.localeCompare(b.template.dataset.eventId));
        if (!candidates.length) return;
        this.querySelector('[data-search-event-result]').replaceChildren(candidates[0].template.content.cloneNode(true));
        this.querySelector('#jpi-search-event-title').textContent = candidates[0].template.dataset.eventHeading;
        this.querySelector('[data-search-event]').hidden = false;
      }
      async normalizeProducts() {
        const root = document.querySelector('[data-jpi-search-section]');
        const types = root?.dataset.jpiSearchTypes.split(',') || [];
        if (!types.includes('product') || types.length === 1) return;
        const originalURL = location.href;
        const url = new URL(originalURL);
        url.searchParams.set('type', 'product');
        url.searchParams.set('section_id', this.dataset.section);
        this.productController = new AbortController();
        const timer = setTimeout(() => this.productController.abort(), 12000);
        try {
          const response = await fetch(url, { signal: this.productController.signal });
          if (!response.ok) throw new Error('Product results unavailable');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = parsed.querySelector('[data-jpi-search-products]');
          const current = root.querySelector('[data-jpi-search-products]');
          if (!incoming || !current || !this.isConnected || location.href !== originalURL) return;
          incoming.querySelectorAll('.scroll-trigger').forEach(item => item.classList.add('scroll-trigger--cancel'));
          current.replaceWith(incoming);
          root.dataset.jpiSearchTypes = 'product';
          url.searchParams.delete('section_id');
          history.replaceState({ ...history.state, searchParams: url.searchParams.toString() }, '', url);
        } catch (error) {
          // Preserve the usable server-rendered results if the additional request fails.
        } finally { clearTimeout(timer); }
      }
      async load(page, focusHeading) {
        if (!Number.isSafeInteger(page) || page < 1) return;
        this.readingController?.abort();
        const controller = new AbortController();
        this.readingController = controller;
        const status = this.querySelector('[data-reading-status]');
        const results = this.querySelector('[data-reading-results]');
        status.textContent = this.dataset.loading;
        results.setAttribute('aria-busy', 'true');
        const timer = setTimeout(() => controller.abort(), 12000);
        try {
          const response = await fetch(this.searchURL('article,page', page), { signal: controller.signal });
          if (!response.ok) throw new Error('Reading results unavailable');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = parsed.querySelector('jpi-search-reading[data-ready="true"] [data-reading-results]');
          if (!incoming) throw new Error('Reading section unavailable');
          if (this.readingController !== controller || !this.isConnected) return;
          results.replaceChildren(...incoming.childNodes);
          this.repairReadingLinks();
          this.dataset.ready = 'true';
          status.textContent = '';
          if (focusHeading) {
            this.querySelector('h2').focus({ preventScroll: true });
            this.scrollIntoView({ block: 'start', behavior: 'auto' });
          }
        } catch (error) {
          if (this.readingController === controller && this.isConnected) status.textContent = this.dataset.error;
        } finally {
          clearTimeout(timer);
          if (this.readingController === controller) results.removeAttribute('aria-busy');
        }
      }
    });
  }
  /* TIMESTAMP END 2026-10-25T10:26:43-04:00 | REVISION R000037 */
  } catch(e) { console.error(e); }
})();

})();
